import { render } from "./i18n.md?vue&type=template&id=76b28b22"
const script = {}
script.render = render

export default script